module.exports = __webpack_public_path__ + "static/paulette_2-4c0f2ee0124a08a58e08b0c047d07d22.jpg";